<template>
  <div class="custome-base-style"> 
    <div class="fixed-button" :class="type === 'new' && 'detail-base-add-style'" v-if="!isFreeze">
      <el-button class="global-btn info" @click="cancle">取消</el-button>
      <el-button class="global-btn primary" @click="save">保存</el-button>
    </div>
    <el-form :model="info" :rules="rules" ref="customeBaseInfo" class="c-detail-custome">
      <div class="base-info-left">
        <div class="form-list-info c-detail-user-detail">
          <h1 class="title section-title">基本资料</h1>
          <div class="base-col base-col-2">
            <div class="item">
              <span class="label" :class="isRequiredClass">客户姓名：</span>
                <el-form-item class="lebel-con custome-yixiang" prop="name" v-if="!isFreeze" ref="name">
                  <el-input placeholder="请输入客户姓名" v-model="info.name"/>
                </el-form-item>
                <span class="result result-ellipse" v-else>{{info.name || '--'}}</span>
            </div>
            <div class="item">
              <span class="label label-required">客户等级
                <el-tooltip placement="bottom-start" class="info-tips"  popper-class="custome-tooltip">
                  <div slot="content">
                    <p class="level-desc">客户等级划分：</p>
                    <p class="level-desc" v-for="levelName in Object.keys(levels)" :key="levelName">{{levelName}}：{{levels[levelName]}}</p>
                  </div>
                  <i class="iconfont iconwenti_yiwen"></i>
                </el-tooltip>
                ：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con custome-level" prop="level" style="margin-right:10px;" ref="level">
                  <el-select v-model="info.level" placeholder="请选择客户等级">
                    <el-option v-for="(level, key) in options.customer_levels" :key="key" :label="level" :value="key" :disabled="key == 99"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <p class="result result-level" v-else>{{options.customer_levels[info.level] || '--'}}</p>
            </div>
            <div class="item">
              <span class="label" :class="isRequiredClass">客户状态：</span>
              <p class="result result-ellipse">{{info.latest_stage_name || '--'}}</p>
            </div>
            <div class="item">
              <span class="label" :class="isRequiredClass">联系号码：</span>
              <p class="result result-ellipse">{{info.contact_tel || '--'}}</p>
            </div>
            <div class="item">
              <span class="label" :class="isRequiredClass">来源：</span>
              <p class="result result-ellipse">{{info.all_source_name || '--'}}</p>
            </div>
            <div class="item">
              <span class="label" :class="isRequiredClass">报名楼盘：</span>
              <p class="result result-ellipse">{{info.sign_up_house_names || '--'}}</p>
            </div>
            <div class="item">
              <span class="label" :class="isRequiredClass">归属地：</span>
              <p class="result result-ellipse">{{info.contact_tel_location || '--'}}</p>
            </div>
            <div class="item">
              <span class="label">客户当前地：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con" prop="location" ref="location">
                  <el-radio-group v-model="info.location">
                    <el-radio :label="key" size="medium" :key="key" v-for="(location, key) in options.customer_locations">{{location}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
              <p v-else class="result result-ellipse">{{options.customer_locations[info.location] || '--'}}</p>
            </div>
            <div class="item">
              <span class="label">购房资质：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con" prop="qualifications" ref="qualifications">
                  <el-radio-group v-model="info.qualifications">
                    <el-radio :label="key" size="medium" v-for="(quality, key) in options.customer_qualifications" :key="key">{{quality}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{options.customer_qualifications && options.customer_qualifications[info.qualifications] || '--'}}</p>
            </div>
            <div class="item">
              <span class="label">购买次数：</span>
              <p class="result result-ellipse">{{info.buy_times || 0}}次数</p>
            </div>
          </div>
        </div>
        <div class="form-list-info c-detail-user-detail" v-if="info.dy_info && (info.dy_info.dy_no || info.dy_info.dy_nickname)">
          <h1 class="title section-title">抖音私域来源</h1>
          <div class="base-col base-col-2">
            <div class="item">
              <span class="label">抖音账号：</span>
                <span class="result result-ellipse" v-if="JSON.stringify(info.dy_info) == '[]'">--</span>
                <span class="result result-ellipse" v-else>{{info.dy_info.dy_nickname ? info.dy_info.dy_nickname : ''}}{{info.dy_info.dy_no ? '('+info.dy_info.dy_no +')': ''}}</span>
            </div>
          </div>
        </div>
        <div class="form-list-info c-detail-user-detail">
          <h1 class="title section-title">需求信息</h1>
          <div class="base-col base-col-2">
            <div class="item item-input-top">
              <span class="label">购房类型：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con custome-level" prop="require_type" ref="require_type">
                  <el-select v-model="info.require_type" placeholder="请选择购房类型">
                    <el-option v-for="(value, key) in options.require_type" :key="key" :label="value" :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{options.require_type && options.require_type[info.require_type] || '--'}}</p>
            </div>
            <div class="item item-flexall mt10">
              <span class="label">意向区域：</span>
              <el-form-item class="lebel-con label-night" prop="city_area_id" ref="city_area_id">
                <area-auto-complete class="user-mutiple-area" v-model="info.city_area_id" :multiple="true" :disabled="isFreeze" placeholder="请选择意向区域（最多三项）" :allowCreate="true"></area-auto-complete>
              </el-form-item>
            </div>
            <div class="item item-flexall mt5" v-if="info.require_type == 1">
              <span class="label">意向项目：</span>
              <el-form-item class="lebel-con label-night" prop="intention_project_ids" ref="intention_project_ids">
                <project-auto-complete class="user-mutiple-area" :isAll="true"  placeholder="请输入意向项目（最多三项）" v-model="info.intention_project_ids" :multiple="true" :disabled="isFreeze" :allowCreate="true"></project-auto-complete>
              </el-form-item>
            </div>
            <div class="item item-flexall mt5" v-if="info.require_type == 2">
              <span class="label">意向小区：</span>
              <el-form-item class="lebel-con label-night" prop="esf_community" ref="esf_community">
                <el-input placeholder="请输入意向小区（最多三项），用;隔开" v-model="info.esf_community" maxlength="50" v-if="!isFreeze" clearable  />
                <p class="result result-ellipse" v-else>{{info.esf_community}}</p>
              </el-form-item>
            </div>
            <div class="item item-flexall mt5" v-if="info.require_type == 2">
              <span class="label">意向二手房：</span>
              <el-form-item class="lebel-con label-night" prop="esf_address" ref="esf_address">
                <el-input placeholder="请输入意向二手房楼栋、房号" v-model="info.esf_address" maxlength="50" v-if="!isFreeze" clearable  />
                <p class="result result-ellipse" v-else>{{info.esf_address}}</p>
              </el-form-item>
            </div>
            <div class="item item-input-top">
              <span class="label">面积：</span>
              <div class="lebel-con label-area">
                <template v-if="!isFreeze">
                  <el-form-item prop="area" ref="area">
                    <el-input placeholder="最小" style="width:80px;" v-model="info.area_min" />
                    <span class="range range-1">—</span>
                    <el-input placeholder="最大" style="width:80px;" v-model="info.area_max" />
                    <span class="range">㎡</span>
                  </el-form-item>
                </template>
                <p class="result result-ellipse" v-else>{{getArea}}</p>
              </div>
            </div>
            <div class="item item-input-top">
              <span class="label">价格：</span>
              <div class="lebel-con label-area">
                <template v-if="!isFreeze">
                  <el-form-item prop="price" ref="price">
                    <el-input placeholder="最小" style="width:80px;" v-model="info.price_min" />
                    <span class="range range-1">—</span>
                    <el-input placeholder="最大" style="width:80px;" v-model="info.price_max" />
                  </el-form-item>
                  <span class="range">万元</span>
                </template>
                <p class="result result-ellipse" v-else>{{getPrice}}</p>
              </div>
            </div>
            <div class="item item-input-top">
              <span class="label">意向楼层：</span>
              <div class="lebel-con label-area">
                <template v-if="!isFreeze">
                  <el-form-item prop="floor" ref="floor">
                    <el-input placeholder="最小" style="width:80px;" v-model="info.floor_min" />
                    <span class="range range-1">—</span>
                    <el-input placeholder="最大" style="width:80px;" v-model="info.floor_max" />
                  </el-form-item>
                  <span class="range">层</span>
                </template>
                <p class="result result-ellipse" v-else>{{getFloor}}</p>
              </div>
            </div>
            <div class="item item-input-top">
              <span class="label">朝向：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con custome-level" prop="orientation" ref="orientation">
                  <el-select v-model="info.orientation" placeholder="请选择朝向">
                    <el-option v-for="(orientations, key) in options.orientations" :key="key" :label="orientations" :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{options.orientations[info.orientation] || '--'}}</p>
            </div>
            <div class="item item-flexall">
              <span class="label">意向户型：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con" prop="room_id" ref="room_id">
                  <el-checkbox-group v-model="info.room_id">
                    <el-checkbox v-for="(layout, key) in options.rooms" :label="key" :key="key" :value="key" >{{layout}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{getRoom}}</p>
            </div>
            <div class="item item-flexall" style="padding-top: 8px;">
              <span class="label">物业类型：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con" prop="house_type" ref="house_type">
                  <el-checkbox-group v-model="info.house_type">
                    <el-checkbox v-for="(type, key) in options.house_types" :label="key" :key="key" :value="key" >{{type}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{getHouseType}}</p>
            </div>
            <div class="item item-flexall" style="padding-top: 8px;">
              <span class="label">意向标签：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con" prop="label" ref="label">
                  <el-checkbox-group v-model="info.label">
                    <el-checkbox v-for="(type, key) in options.customer_label" :label="key" :key="key" :value="key" >{{type}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{getLabel}}</p>
            </div>
            <div class="item">
              <span class="label">装修：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con" prop="decoration" ref="decoration">
                  <el-checkbox-group v-model="info.decoration">
                    <el-checkbox v-for="(decoration, key) in options.decorations" :label="key" :key="key" :value="key" >{{decoration}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{getDecoration}}</p>
            </div>
            <div class="item item-flexall">
              <span class="label">备注：</span>
              <template v-if="!isFreeze">
                <el-form-item class="lebel-con custome-remark" prop="remark" ref="remark">
                  <el-input type="textarea" placeholder="请输入备注" :show-word-limit="true" maxlength="300" :rows="4" v-model="info.remark" />
                </el-form-item>
              </template>
              <p class="result result-ellipse" v-else>{{info.remark || '--'}}</p>
            </div>
          </div>
        </div>
        <div class="form-list-info c-detail-user-detail">
          <div class="admin-concat clearfix">
            <h1 class="title section-title floatL">联系人</h1>
            <el-button class="global-btn primary floatL " icon="el-icon-plus" @click="addConcat" v-if="baseInfo.allow_add_contact">添加</el-button>
          </div>
          <div class="clearfix">
            <div class="concat-item" v-for="user in concats" :key="user.id">
              <div class="ci-header">
                <span class="zhu" v-if="user.is_main === 1">主</span>
                <h1 class="name">{{user.name || ''}}</h1>
                <span class="gender">{{user.gender === 1 ? '先生' : user.gender === 2 ? '女士' : '未知'}}</span>
              </div>
              <p class="mobile">{{user.tel || ''}}  <span class="empty_tip" v-if="user.is_tel_empty == 1">(空号)</span></p>
              <p class="btn-group">
                <a class="btn" v-if="user.is_main !== 1 && baseInfo.allow_add_contact" @click="concatSetMain(user.id)" >设为主联系</a>
                <a class="btn" @click="concatEdit(user, 'show')">查看</a>
                <a class="btn" @click="concatEdit(user)" v-if="baseInfo.allow_add_contact">编辑</a>
              </p>
            </div>
          </div>
        </div>
        <div class="form-list-info c-detail-user-detail">
          <h1 class="title section-title">数据信息</h1>
          <div class="base-col base-col-2">
            <div class="item item-text">
              <span class="label">获客方式：</span>
              <p class="result result-ellipse">{{info.create_type_name || '--'}}</p>
            </div>
            <div class="item item-text">
              <span class="label">创建人：</span>
              <p class="result result-ellipse">{{info.creator_name || '--'}}</p>
            </div>
            <div class="item item-text">
              <span class="label">创建时间：</span>
              <p class="result result-ellipse" v-analysis-time="info.created_at"></p>
            </div>
            <div class="item item-text">
              <span class="label">首次分配：</span>
              <p class="result result-ellipse" v-analysis-time="info.first_distribution_time"></p>
            </div>
            <div class="item item-text">
              <span class="label">分配时间：</span>
              <p class="result result-ellipse" v-analysis-time="info.latest_distribution_time"></p>
            </div>
            <div class="item item-text">
              <span class="label">最后跟进：</span>
              <p class="result result-ellipse" v-analysis-time="info.latest_follow_up_time"></p>
            </div>
            <div class="item item-text">
              <span class="label">下次跟进：</span>
              <p class="result result-ellipse" v-analysis-time="info.next_follow_up_time"></p>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import {configKeys} from '@/setting/index';
import {validateMobile, validateUserName} from '@/utils/validate';
import {customeAdd, getLevelDesc, customeEdit, customConcatList,customeConcatSetMain} from '@/api/custome';
import AreaAutoComplete from '@/components/select/AreaAutoComplete';
import ProjectAutoComplete from '@/components/select/ProjectAutoComplete';
import { mapState } from 'vuex';
export default {
  components: { AreaAutoComplete, ProjectAutoComplete },
  name: 'CustomeBaseInfo',
  props: {
    type: {
      type: String,
      default: 'show'
    },
    customeId: [Number, String],
    baseInfo: Object,
    tel: String,
    closed: Function,
    initCb: Function
  },
  watch: {
    baseInfo () {
      this.info = this.baseInfo;
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      emitName: state => state.const.emitName
    }),
    isFreeze () {
      return this.type !== 'new' && !this.info.allow_edit;
    },
    isRequiredClass () {
      return this.type === 'new' ? 'label-required' : '';
    },
    getArea () {
      if (!this.info.area_max && !this.info.area_min) return '--';
      else if (!this.info.area_max) return `最低${this.info.area_min}㎡`
      else if (!this.info.area_min) return `最高${this.info.area_max}㎡`
      return `${this.info.area_min}-${this.info.area_max}㎡`;
    },
    getPrice () {
      if (!this.info.price_max && !this.info.price_min) return '--';
      else if (!this.info.price_max) return `最低${this.info.price_min}万元`
      else if (!this.info.price_min) return `最高${this.info.price_max}万元`
      return `${this.info.price_min}-${this.info.price_max}万元`;
    },
    getFloor () {
      if (!this.info.floor_min && !this.info.floor_max) return '--';
      else if (!this.info.floor_max) return `最低${this.info.floor_max}层`
      else if (!this.info.floor_min) return `最高${this.info.floor_min}层`
      return `${this.info.floor_min}-${this.info.floor_max}层`;
    },
    getRoom () {
      if (!(this.info.room_id && this.info.room_id.length > 0)) return '--';
      return this.info.room_id.map(v => this.options.rooms[v]).join(',');
    },
    getHouseType () {
      if (!(this.info.house_type && this.info.house_type.length > 0)) return '--';
      return this.info.house_type.map(v => this.options.house_types[v]).join(',');
    },
    getLabel () {
      if (!(this.info.label && this.info.label.length > 0)) return '--';
      return this.info.label.map(v => this.options.customer_label[v]).join(',');
    },
    getDecoration () {
      if (!(this.info.decoration && this.info.decoration.length > 0)) return '--';
      return this.info.decoration.map(v => this.options.decorations[v]).join(',');
    }
  },
  async created () {
    this.initConcatAll();
    const keys = [configKeys.customer_levels, configKeys.customer_offline_channels, configKeys.customer_locations,
          configKeys.customer_qualifications, configKeys.rooms, configKeys.house_types, configKeys.decorations, configKeys.orientations, 'require_type', 'customer_label'];
    this.options = await this.$store.dispatch('initConfig', keys);
    this.info = this.baseInfo;
    if (this.info.require_type) {
      this.info.require_type = `${this.info.require_type}`
    } else {
      this.info.require_type = `1`
    }
    this.getLevelAll();
  },
  beforeDestroy () {
    this.info= {
      room_id: [],
      house_type: [],
      label: [],
      decoration: [],
      city_area_id: [],
      intention_project_ids: [],
      require_type: '1',
      esf_community: ''
    }
  },
  data () {
    // 面积校验
    const validateArea = (rule, value, callback) => {
      const max = this.info['area_max'];
      const min = this.info['area_min'];
      if (!max && !min) {
        callback();
      } else if (min && !/^([1-9][0-9]{0,5})$/.test(`${min}`)) {
        callback(`最小面积为1-999999之间的整数类型`);
      } else if (max && !/^([1-9][0-9]{0,5})$/.test(`${max}`)) {
        callback(`最大面积为1-999999之间的整数类型`);
      } else if (!!max && !!min && Number(max) < Number(min)) {
        callback('最小面积不能大于最大面积');
      } else {
        callback();
      }
    }
    // 价格校验
    const validatePrice = (rule, value, callback) => {
      const max = this.info['price_max'];
      const min = this.info['price_min'];
      if (!max && !min) {
        callback();
      } else if (min && !/^([1-9][0-9]{0,5})$/.test(`${min}`)) {
        callback(`最小价格为1-999999之间的整数`);
      } else if (max && !/^([1-9][0-9]{0,5})$/.test(`${max}`)) {
        callback(`最大价格为1-999999之间的整数`);
      }else if (!!max && !!min && Number(max) < Number(min)) {
        callback('最小价格不能大于最大价格');
      } else {
        callback();
      }
    }
    // 楼层校验
    const validateFloor = (rule, value, callback) => {
      const max = Number(this.info['floor_max']);
      const min = Number(this.info['floor_min']);
      if (!max && !min) {
        callback();
      } else if (min == 0 || !/^(\d{1,2})$/.test(min)) {
        callback(`最小楼层在1-99之间`);
      } else if (max ==0 || !/^(\d{1,2})$/.test(max)) {
        callback(`最大楼层在1-99之间`);
      }else if (!!max && !!min && Number(max) < Number(min)) {
        callback('最小楼层不能大于最大楼层');
      } else {
        callback();
      }
    }
    return {
      info: {
        room_id: [],
        house_type: [],
        label: [],
        decoration: [],
        city_area_id: [],
        intention_project_ids: [],
        require_type: '1',
        esf_community: ''
      },
      options: {
        customer_levels: {},
        customer_offline_channels: {},
        customer_locations: {},
        rooms: {},
        house_types: {},
        customer_label: {},
        decorations: {},
        orientations: {}
      },
      rules: {
        name: [
          {required: true, message: '请输入客户姓名', trigger: 'blur'},
          {min: 1, max: 20, message: '客户姓名长度在1-20之间', trigger: 'blur'}
        ],
        contact_name: [
          {required: true, message: '请输入联系人姓名', trigger: 'blur'},
          {min: 1, max: 20, message: '联系人姓名长度在1-20之间', trigger: 'blur'}
        ],
        level: [
          {required: true, message: '请选择客户等级', trigger: 'change'}
        ],
        channel: [
          {required: true, message: '请选择来源渠道', trigger: 'change'}
        ],
        contact_tel: [
          {validator: validateMobile, name: '联系电话', trigger: 'blur'}
        ],
        area: [
          {validator: validateArea, trigger: 'blur'}
        ],
        price: [
          {validator: validatePrice, trigger: 'blur'}
        ],
        floor: [
          {validator: validateFloor, trigger: 'blur'}
        ]
      },
      levels: {},
      concats: []
    }
  },
  methods: {
    cancle () {
      this.initCb && this.initCb();
    },
    // 保存/编辑
    save () {
      this.$refs.customeBaseInfo && this.$refs.customeBaseInfo.validate(async (valid, dom) => {
        if (!valid) {
          this.validateError(dom);
          return null;
        };
        try {
          const params = Object.assign({}, this.info, {
            room_id: this.info.room_id.join(','),
            house_type: this.info.house_type.join(','),
            label: this.info.label.join(','),
            decoration: this.info.decoration.join(',')
          });
          let paramters = {};
          ['esf_community','level', 'location', 'qualifications', 'city_area_id', 'intention_project_ids','area_min', 'area_max', 'price_min', 'price_max', 'floor_min', 'floor_max', 'require_type',
            'room_id', 'house_type', 'label', 'decoration', 'orientation', 'remark', 'esf_address'].map(v => {
              if (params[v] || params[v] === 0) paramters[v] = params[v];
            })
          if (paramters.require_type != undefined) {
            paramters.require_type = Number(paramters.require_type);
          }
           // 拼接意向区域
           if (params.city_area_id && this.info.city_area_id.length > 0) {
            const ids = [];
            const names = [];
            params.city_area_id.map(v => {
              if (typeof v == 'string') {
                ids.push(0);
                names.push(v);
              } else {
                ids.push(v.id);
                names.push(v.name);
              }
            })
            paramters.city_area_id = ids.join(',');
            paramters.city_area_name = names.join(',');
          }else{
            paramters.city_area_id = '';
            paramters.city_area_name = '';
          }
          if (!!params.intention_project_ids && typeof params.intention_project_ids === 'object') {
            const ids = [];
            const names = [];
            params.intention_project_ids.map(v => {
              if (typeof v == 'string') {
                ids.push(0);
                names.push(v);
              } else {
                ids.push(Number(v.id));
                names.push(v.name);
              }
            })
            paramters.intention_project_ids = ids.join(',');
            paramters.intention_project_names = names.join(',');
          } else {
            paramters.intention_project_ids = '';
          }

          paramters.name = this.info.name;
          if (paramters.require_type == 1) {
            delete paramters.esf_community;
            delete paramters.esf_address;
          } else if (paramters.require_type == 2) {
            delete paramters.intention_project_ids;
          }
          await customeEdit(this.customeId ,paramters);
          this.$message.success('操作用户信息成功')
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试')
        }
      })
    },
    validateError (object) {
      let split = '';
      for (let i in object) {
        let dom = this.$refs[i];
        if (Object.prototype.toString.call(dom) !== '[object Object]') {
          dom = dom[0];
          split = dom.prop;
          let index = split.indexOf('.');
          let last = split.lastIndexOf('.');
          this.activeName = Number(split.slice(index + 1, last));
          break;
        }
        dom.$el.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        })
      }
    },
    refrensh () {
      this.initConcatAll();
      this.$refs.customeBaseInfo?.clearValidate();
    },
    async getLevelAll () {
      try {
        const res = await getLevelDesc({
          name: 'customer_level_desc'
        });
        this.levels = res;
      } catch (error) {
      }
    },
    async initConcatAll () {
      try {
        const res = await  customConcatList(this.customeId, {
          per_page: 50,
          page: 1
        })
        this.concats = res.data ?? [];
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    addConcat () {
      this.$EventBus.$emit(this.emitName, {category: 'concat', params: {
        type: 'new',
        tabActiveName: this.activeName,
        baseInfo: {
          customer_name: this.baseInfo.name,
          customer_id: this.baseInfo.id
        }
      }});
    },
    concatEdit (info, type = 'edit') {
      this.$EventBus.$emit(this.emitName, {category: 'concat', params: {
        type: type,
        tabActiveName: this.activeName,
        baseInfo: {
        ...info,
        customer_id: this.baseInfo.id,
        customer_name: this.baseInfo.name
      }}});
    },
    // 设为主联系人
    async concatSetMain (id) {
      try {
        await customeConcatSetMain(this.customeId, id);
        this.$message.success('您已成功设置当前联系人为主联系人');
        this.initConcatAll();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
  }
}
</script>
<style scoped lang="less">
.custome-base-style{
  padding-top: 10px;
  height: calc(100VH - 205px);
  overflow-y: scroll;
  .c-detail-custome .c-detail-user-detail{
    padding: 15px 20px 5px 20px;
  }
  .c-detail-custome{
    .concat-item{
      .btn-group{
        display: flex;
        justify-content: space-between;
        .btn{
          margin-left: 0;
        }
      }
    }
  }
  .section-title{
    color: #000;
    font-size: 14px;
    margin-bottom: 6px;
    &::before{
      content: '';
      width: 5px;
      height: 15px;
      background: #3168FF;
      display: inline-block;
      vertical-align: -2px;
      margin-right: 8px;
      border-radius: 3px;
    }
  }
  .form-list-info .item .result-ellipse,.form-list-info .item .label{
    font-size: 12px;
  }
  .form-list-info .item{
    padding-top: 5px;
  }
  .form-list-info .item-input-top{
    padding-top: 10px;
  }
  .mt5{margin-top: 5px !important;}
}
.label-area{
  display: -webkit-box !important;
}
.custom-btn{
  padding-left: 105px;
}
.empty_tip{
  color:#999;
  margin-left:10px;
}
</style>
<style lang="less">
.label-night .el-form-item__content{
  width: 90% !important;
  max-width: 700px !important;
}
.user-mutiple-area{
  .el-tag.el-tag--info{
    background: transparent;
    border-color: transparent;
  }
  .el-tag.el-tag--info .el-tag__close,.el-tag.el-tag--info .el-tag__close:hover{
    font-size: 18px;
    background: transparent;
    left: 0;
    top:-1px;
    color: #999;
  }
}
.base-write{
  position: absolute;
  right: 25px;
  height: 32px;
  line-height: 30px;
  font-size: 14px;
  padding: 0 8px;
  background: #25a0ff;
  border-color: #25a0ff !important;
  color: #FFF  !important;
}
.detail-base-add-style{
  padding-right: 30px;
  text-align: right;
}

</style>
